module.exports = __webpack_public_path__ + "img/access_denied.344b2f11.svg";